/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneA2aAgentsRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneA2aAgentsRoute, {
  overrideRenderTemplate: false,
});
